import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import '../style/dashboard.css';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// --- Professional Icons ---
const IconWrapper = ({ children, bgColor, color }) => (
    <div style={{
        width: '46px',
        height: '46px',
        borderRadius: '12px',
        backgroundColor: bgColor,
        color: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '12px'
    }}>
        {children}
    </div>
);

const PartyCadreIcon = () => <IconWrapper bgColor="#fff7ed" color="#ea580c"><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/><path d="M12 13c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg></IconWrapper>;
const PersonalCadreIcon = () => <IconWrapper bgColor="#eff6ff" color="#2563eb"><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/></svg></IconWrapper>;
const CallCenterIcon = () => <IconWrapper bgColor="#f0fdf4" color="#16a34a"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"/></svg></IconWrapper>;
const UserIcon = () => <IconWrapper bgColor="#f5f3ff" color="#7c3aed"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg></IconWrapper>;
const BoothIcon = () => <IconWrapper bgColor="#fee2e2" color="#dc2626"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"/></svg></IconWrapper>;
const PhonebookIcon = () => <IconWrapper bgColor="#faf5ff" color="#9333ea"><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/></svg></IconWrapper>;
const DateIcon = () => <IconWrapper bgColor="#ecfdf5" color="#059669"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></IconWrapper>;
const DeathIcon = () => <IconWrapper bgColor="#f1f5f9" color="#475569"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg></IconWrapper>;
const ShiftIcon = () => <IconWrapper bgColor="#fff7ed" color="#d97706"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg></IconWrapper>;
const WrongNumIcon = () => <IconWrapper bgColor="#fdf2f8" color="#e11d48"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M10.5 10.5l3 3m0-3l-3 3M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/></svg></IconWrapper>;
const CallMissedIcon = () => <IconWrapper bgColor="#f8fafc" color="#334155"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M16 2v4m-2-2h4M3.5 10A18.5 18.5 0 0021 21M3.5 10c0-3.5 2.5-6 6-6s6 2.5 6 6M3.5 10v4c0 3.5 2.5 6 6 6s6-2.5 6-6v-4"/></svg></IconWrapper>;

const SurveyDashboard = () => {
    const navigate = useNavigate();
    const { appId, total_voters, language, userType } = useAppId();
    
    const lang = language || 'en';

    // --- ROLE VERIFICATION LOGIC ---
    const roleCode = userType?.toUpperCase() || '';
    const isAdmin = roleCode === 'A' || roleCode === 'ADMIN';
    const isSubAdmin = roleCode === 'SA' || roleCode === 'SUB_ADMIN';
    const showSurveySection = isAdmin || isSubAdmin;

    const t = {
        en: {
            title: "Survey Dashboard",
            subtitle: "Overview of survey progress and reports.",
            totalVoters: "Total Voters",
            totalSurveyed: "Total Surveyed",
            totalPending: "Total Pending",
            done: "Done",
            unavailable: "Unavailable :",
            positive: "Positive",
            negative: "Negative",
            doubtful: "Doubtful",
            notInterested: "Can't say",
            surveySection: "SURVEY",
            otherReport: "OTHER REPORT",
            partyCadreSurvey: "Party Cadre Survey",
            personalCadreSurvey: "Candidate Cadre Survey",
            callCenterSurveyOption: "Call Center Survey",
            userWiseSurvey: "User Wise Survey",
            boothPramukhSurvey: "Booth Pramukh Survey",
            shaktiKendraSurvey: "Shakti Kendra Survey",
            phonebookSurvey: "Phonebook Survey",
            boothWiseSurvey: "Booth Wise Survey",
            dateWiseSurvey: "Date Wise Survey",
            deathSurvey: "Death Survey",
            shiftSurvey: "Shift Survey",
            wrongNumberVoter:"Wrong Number Voter",
            callNotReceivedVoter:"Call Not Received Voter"
        },
        hi: {
            title: "सर्वेक्षण डैशबोर्ड",
            subtitle: "सर्वेक्षण प्रगति और रिपोर्ट का अवलोकन।",
            totalVoters: "कुल मतदाता",
            totalSurveyed: "कुल सर्वेक्षित",
            totalPending: "कुल लंबित",
            done: "पूर्ण",
            unavailable: "अनुपलब्ध :",
            positive: "सकारात्मक",
            negative: "नकारात्मक",
            doubtful: "संदिग्ध",
            notInterested: "कह नहीं सकते",
            surveySection: "सर्वेक्षण",
            otherReport: "अन्य रिपोर्ट",
            partyCadreSurvey: "पार्टी कार्यकर्ता सर्वेक्षण",
            personalCadreSurvey: "उम्मीदवार कार्यकर्ता सर्वेक्षण",
            callCenterSurveyOption: "कॉल सेंटर सर्वेक्षण",
            userWiseSurvey: "उपयोगकर्ता वार सर्वेक्षण",
            boothPramukhSurvey: "बूथ प्रमुख सर्वेक्षण",
            shaktiKendraSurvey: "शक्ति केंद्र सर्वेक्षण",
            phonebookSurvey: "फोनबुक सर्वेक्षण",
            boothWiseSurvey: "बूथ वार सर्वेक्षण",
            dateWiseSurvey: "तिथि वार सर्वेक्षण",
            deathSurvey: "मृत्यु सर्वेक्षण",
            shiftSurvey: "स्थानांतरण सर्वेक्षण",
            wrongNumberVoter:"गलत नंबर मतदाता",
            callNotReceivedVoter:"कॉल नहीं प्राप्त मतदाता"
        },
        gu: {
            title: "સર્વે ડેશબોર્ડ",
            subtitle: "સર્વે પ્રગતિ અને રિપોર્ટ્સની ઝાંખી.",
            totalVoters: "કુલ મતદારો",
            totalSurveyed: "કુલ સર્વેક્ષણ",
            totalPending: "કુલ બાકી",
            done: "પૂર્ણ",
            unavailable: "અનુપલબ્ધ :",
            positive: "હકારાત્મક",
            negative: "નકારાત્મક",
            doubtful: "શંકાસ્પદ",
            notInterested: "કહે નહીં",
            surveySection: "સર્વે",
            otherReport: "અન્ય રિપોર્ટ",
            partyCadreSurvey: "પાર્ટી કેડર સર્વે",
            personalCadreSurvey: "ઉમેદવાર કેડર સર્વે",
            callCenterSurveyOption: "કોલ સેન્ટર સર્વે",
            userWiseSurvey: "યુઝર પ્રમાણે સર્વે",
            boothPramukhSurvey: "બૂથ પ્રમુખ સર્વે",
            shaktiKendraSurvey: "શક્તિ કેન્દ્ર સર્વે",
            phonebookSurvey: "ફોનબુક પ્રમાણે સર્વે",
            boothWiseSurvey: "બૂથ પ્રમાણે સર્વે",
            dateWiseSurvey: "તારીખ પ્રમાણે સર્વે",
            deathSurvey: "મૃત્યુ સર્વે",
            shiftSurvey: "સ્થળાંતર સર્વે",
            wrongNumberVoter:"ખોટા નંબર મતદાર",
            callNotReceivedVoter:"કોલ ન મળેલ મતદાર"
        }
    };

    const txt = t[lang];

    const [data, setData] = useState({
        totalVoters: 0,
        totalSurveyed: 0,
        totalPending: 0,
        pieData: [
            { name: txt.positive, value: 0, color: '#10b981' },
            { name: txt.negative, value: 0, color: '#ef4444' },
            { name: txt.doubtful, value: 0, color: '#f59e0b' },
            { name: txt.notInterested, value: 0, color: '#6366f1' },
        ],
        unavailable: 0,
    });

    useEffect(() => {
        setData(prev => ({
            ...prev,
            pieData: [
                { name: txt.positive, value: prev.pieData[0]?.value || 0, color: '#10b981' },
                { name: txt.negative, value: prev.pieData[1]?.value || 0, color: '#ef4444' },
                { name: txt.doubtful, value: prev.pieData[2]?.value || 0, color: '#f59e0b' },
                { name: txt.notInterested, value: prev.pieData[3]?.value || 0, color: '#6366f1' },
            ]
        }));
    }, [lang, txt.positive, txt.negative, txt.doubtful, txt.notInterested]);

    useEffect(() => {
        if (appId) {
            fetchData();
        }
    }, [appId]);

    const fetchData = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_survey_dash_for_admin`, {
                app_id: appId,
                survey_by: " "
            });

            if (response.data.success) {
                const res1 = response.data.data.result[0];
                const res2 = response.data.data.result2[0];

                const totalVoters = total_voters;
                const unavailable = res2.not_available || 0;

                const p = res2.p || 0;
                const n = res2.n || 0;
                const d = res2.d || 0;
                const c = res2.c || 0;

                const totalSurveyed = p + n + d + c;
                const totalPending = totalVoters - totalSurveyed - unavailable;

                setData({
                    totalVoters: totalVoters,
                    totalSurveyed: totalSurveyed,
                    totalPending: totalPending,
                    pieData: [
                        { name: txt.positive, value: p, color: '#10b981' },
                        { name: txt.negative, value: n, color: '#ef4444' },
                        { name: txt.doubtful, value: d, color: '#f59e0b' },
                        { name: txt.notInterested, value: c, color: '#6366f1' },
                    ],
                    unavailable: unavailable,
                });
            }
        } catch (error) {
            console.error("Error fetching survey dashboard data:", error);
        }
    };

    const handleNavigate = (path) => {
        navigate(path);
    };

    const primarySurveyOptions = [
        { title: txt.partyCadreSurvey, icon: <PartyCadreIcon/>, onClick: () => { handleNavigate('/dis_party_cadre_survey_dash') } },
        { title: txt.personalCadreSurvey, icon: <PersonalCadreIcon/>, onClick: () => { handleNavigate('/dis_personal_cadre_survey_dash') } },
        { title: txt.callCenterSurveyOption, icon: <CallCenterIcon/>, onClick: () => { handleNavigate('/dis_call_center_survey_dash') } },
    ];

    const otherReportOptions = [
        { title: txt.userWiseSurvey, icon: <UserIcon/>, onClick: () => { handleNavigate('/dis_user_wise_survey_dash') } },
        { title: txt.boothWiseSurvey, icon: <BoothIcon/>, onClick: () => { handleNavigate('/dis_booth_wise_survey_dash') } },
        { title: txt.phonebookSurvey, icon: <PhonebookIcon/>, onClick: () => { handleNavigate('/dis_phonebook_wise_survey_dash') } },
        { title: txt.dateWiseSurvey, icon: <DateIcon/>, onClick: () => { handleNavigate('/dis_date_wise_survey_dash') } },
        { title: txt.deathSurvey, icon: <DeathIcon/>, onClick: () => { handleNavigate('/dis_death_voter') } },
        { title: txt.shiftSurvey, icon: <ShiftIcon/>, onClick: () => { handleNavigate('/dis_shifted_out_voter') } },
        { title: txt.wrongNumberVoter, icon: <WrongNumIcon/>, onClick: () => { handleNavigate('/dis_wrong_mobile_no_voter') } },
        { title: txt.callNotReceivedVoter, icon: <CallMissedIcon/>, onClick: () => { handleNavigate('/dis_call_not_received_voter') } },
    ];

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        const RADIAN = Math.PI / 180;
        const radius = outerRadius + 20;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="#334155" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize="12" fontWeight="600">
                {`${(percent * 100).toFixed(1)}%`}
            </text>
        );
    };

    return (
        <div className="app-container dashboard-page">
            <div className="dashboard-content container-fluid p-4">

                <Header title={txt.title}/>

                <div className="row g-4 mb-5">

                    <div className="col-lg-5 col-md-12">
                        <div className="survey-card h-90 d-flex flex-column justify-content-between">
                            <div className="top-stats-row">
                                <div className="stat-box">
                                    <span className="stat-label">{txt.totalVoters}</span>
                                    <span className="stat-value text-dark">{data.totalVoters}</span>
                                </div>
                                <div className="stat-divider"></div>
                                <div className="stat-box">
                                    <span className="stat-label">{txt.totalSurveyed}</span>
                                    <span className="stat-value text-dark">{data.totalSurveyed}</span>
                                </div>
                                <div className="stat-divider"></div>
                                <div className="stat-box">
                                    <span className="stat-label">{txt.totalPending}</span>
                                    <span className="stat-value text-dark">{data.totalPending}</span>
                                </div>
                            </div>

                            <div className="chart-wrapper">
                                <ResponsiveContainer width="100%" height={280}>
                                    <PieChart>
                                        <Pie
                                            data={data.pieData}
                                            cx="50%"
                                            cy="50%"
                                            innerRadius={80}
                                            outerRadius={110}
                                            paddingAngle={0}
                                            dataKey="value"
                                            startAngle={90}
                                            endAngle={-270}
                                            label={renderCustomizedLabel}
                                            labelLine={true}
                                        >
                                            {data.pieData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
                                            ))}
                                        </Pie>
                                        <Tooltip
                                            formatter={(value) => value.toLocaleString()}
                                            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                        />
                                    </PieChart>
                                </ResponsiveContainer>

                                <div className="chart-center-text">
                                    <span className="survey-percentage">
                                        {data.totalVoters > 0 ? ((data.totalSurveyed / data.totalVoters) * 100).toFixed(1) : 0}%
                                    </span>
                                    <span className="survey-label">{txt.done}</span>
                                </div>
                            </div>

                            <div className="unavailable-pill">
                                {txt.unavailable} <strong>{data.unavailable.toLocaleString()}</strong>
                            </div>

                            <div className="bottom-stats-grid">
                                {data.pieData.map((entry, index) => (
                                    <div key={index} className={`bottom-stat-item ${index !== data.pieData.length - 1 ? 'border-right' : ''}`}>
                                        <span className="b-stat-value" style={{ color: entry.color }}>
                                            {entry.value.toLocaleString()}
                                        </span>
                                        <span className="b-stat-label">{entry.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-12">
                        
                        {/* Survey Section - Only visible for Admin and SubAdmin */}
                        {showSurveySection && (
                            <div className="survey-card mb-4">
                                <div className="pb-4">
                                    <h4 className="section-title">{txt.surveySection}</h4>
                                </div>
                                <div className="row g-3">
                                    {primarySurveyOptions.map((option, index) => (
                                        <div key={index} className="col-4 col-md-4">
                                            <div className="option-card" onClick={option.onClick}>
                                                <div className="option-icon">{option.icon}</div>
                                                <span className="option-text">{option.title}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Other Report Section - Always visible for all users */}
                        <div className="survey-card">
                            <div className="pb-4">
                                <h4 className="section-title">{txt.otherReport}</h4>
                            </div>
                            <div className="row g-3">
                                {otherReportOptions.map((option, index) => (
                                    <div key={index} className="col-6 col-md-4">
                                        <div className="option-card" onClick={option.onClick}>
                                            <div className="option-icon">{option.icon}</div>
                                            <span className="option-text">{option.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <style jsx>{`
                .survey-card {
                    background: white;
                    border-radius: 16px;
                    padding: 24px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.03);
                    border: 1px solid #f1f5f9;
                }

                .top-stats-row {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 20px;
                }
                .stat-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    min-width: 100px;
                }
                .stat-label {
                    font-size: 13px;
                    color: #64748b;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                .stat-value {
                    font-size: 20px;
                    font-weight: 800;
                }
                .stat-divider {
                    width: 1px;
                    height: 40px;
                    background-color: #e2e8f0;
                    margin: 0 12px;
                }

                .chart-wrapper {
                    position: relative;
                    margin: 10px 0 25px 0;
                }
                .chart-center-text {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    pointer-events: none; 
                }
                .survey-percentage {
                    font-size: 22px;
                    font-weight: 800;
                    color: #0f172a;
                }
                .survey-label {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 600;
                    margin-top: 4px;
                }

                .unavailable-pill {
                    background-color: #fef2f2;
                    color: #991b1b;
                    font-weight: 500;
                    font-size: 14px;
                    text-align: center;
                    padding: 8px;
                    border-radius: 6px;
                    border: 1px solid #fecaca;
                    margin-bottom: 20px;
                }

                .bottom-stats-grid {
                    display: flex;
                    justify-content: space-between;
                    border-top: 1px solid #f1f5f9;
                    padding-top: 15px;
                }
                .bottom-stat-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                }
                .border-right {
                    border-right: 1px solid #e2e8f0;
                }
                .b-stat-value {
                    font-size: 18px;
                    font-weight: 800;
                    margin-bottom: 2px;
                }
                .b-stat-label {
                    font-size: 11px;
                    color: #64748b;
                    font-weight: 600;
                }

                .section-title {
                    font-size: 14px;
                    font-weight: 800;
                    color: #1e293b;
                    letter-spacing: 0.5px;
                    margin: 0;
                }
                
                .option-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 20px 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-start;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    height: 100%;
                }
                .option-card:hover {
                    border-color: #3b82f6;
                    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
                    transform: translateY(-2px);
                }
                
                .option-text {
                    font-size: 12px;
                    font-weight: 700;
                    color: #334155;
                    text-align: center;
                    line-height: 1.4;
                }
                
                @media (max-width: 640px) {
                    .option-card { padding: 15px 5px; }
                    .option-text { font-size: 11px; }
                    .stat-box { min-width: 70px; }
                    .stat-value { font-size: 16px; }
                    .stat-divider { margin: 0 8px; }
                }
            `}</style>
        </div>
    );
};

export default SurveyDashboard;